// extracted by mini-css-extract-plugin
export default {"root":"ReviewAllList_root__V+Af-","cardContainer":"ReviewAllList_cardContainer__XFZpf","container":"ReviewAllList_container__NnwO6"};